import { ConcreteEncodable } from './ConcreteEncodable';

import { FwdRollOrderAllocationPricingImplEncoder } from "../../encoder/FwdRollOrderAllocationPricingImplEncoder";

import * as CubiqTS from "../../index";
import { FwdRollOrderAllocationPricing} from "../FwdRollOrderAllocationPricing";

export class FwdRollOrderAllocationPricingImpl extends ConcreteEncodable implements FwdRollOrderAllocationPricing {
  public static enType: string = "com.bcdfx.model.fwdroll.FwdRollOrderAllocationPricingImpl";

  /*FID=1*/
  public baseCcy: string;
  /*FID=2*/
  public nonBaseCcy: string;
  /*FID=3*/
  public fixedCcy: string;
  /*FID=4*/
  public clientIntent: CubiqTS.OrderIntent;
  /*FID=5*/
  public product: CubiqTS.Product;
  /*FID=6*/
  public settleTenor: CubiqTS.Tenor;
  /*FID=7*/
  public settleDate: CubiqTS.moment.Moment|null = null;
  /*FID=8*/
  public fixedAmt: CubiqTS.BigNumber|null = null;
  /*FID=9*/
  public counterAmt: CubiqTS.BigNumber|null = null;
  /*FID=10*/
  public marketSpotRate: CubiqTS.BigNumber|null = null;
  /*FID=11*/
  public marketForwardPts: CubiqTS.BigNumber|null = null;
  /*FID=12*/
  public marketForwardRate: CubiqTS.BigNumber|null = null;
  /*FID=13*/
  public spotMarkup: CubiqTS.BigNumber|null = null;
  /*FID=14*/
  public clientSpotRate: CubiqTS.BigNumber|null = null;
  /*FID=15*/
  public clientForwardPts: CubiqTS.BigNumber|null = null;
  /*FID=16*/
  public clientForwardRate: CubiqTS.BigNumber|null = null;
  /*FID=17*/
  public fwdMarkup: CubiqTS.BigNumber|null = null;
  /*FID=18*/
  public accountName: string;
  /*FID=19*/
  public allocationId: CubiqTS.Long|null = null;
  /*FID=20*/
  public channelCd: string;
  /*FID=21*/
  public clientCode: string;
  /*FID=22*/
  public clientName: string;
  /*FID=23*/
  public entryDts: CubiqTS.moment.Moment|null = null;
  /*FID=24*/
  public entryUserCode: string;
  /*FID=25*/
  public oboAccount: string;
  /*FID=26*/
  public oboClient: string;
  /*FID=27*/
  public oboEntryUser: string;
  /*FID=28*/
  public usdEquivAmt: CubiqTS.BigNumber|null = null;
  /*FID=29*/
  public orderId: CubiqTS.Long|null = null;
  /*FID=30*/
  public orderRef: string;
  /*FID=31*/
  public privateComments: string;
  /*FID=32*/
  public clientComments: string;
  /*FID=33*/
  public salesGroupId: CubiqTS.Long|null = null;
  /*FID=34*/
  public userUpdatedFg: boolean;
  /*FID=35*/
  public forwardFirstOrder: boolean;
  /*FID=36*/
  public reqForwardPts: CubiqTS.BigNumber|null = null;
  /*FID=37*/
  public failedAdjCalculation: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken|null = null;
  /*FID=590*/
  public rowId: string;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long|null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long|null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long|null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long|null = null;
  public sessionOnly: string;
 
  constructor(
    
  ) {
    super();
    this.encoder = FwdRollOrderAllocationPricingImplEncoder.Instance;
    this.setEncodableType(FwdRollOrderAllocationPricingImpl.enType);
    this.messageId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { let r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);  return v.toString(16);});
  };

  public toString(): string {
    return  "FwdRollOrderAllocationPricingImpl["+
            "baseCcy="+this.baseCcy+
            "nonBaseCcy="+this.nonBaseCcy+
            "fixedCcy="+this.fixedCcy+
            "clientIntent="+this.clientIntent+
            "product="+this.product+
            "settleTenor="+this.settleTenor+
            "settleDate="+this.settleDate+
            "fixedAmt="+this.fixedAmt+
            "counterAmt="+this.counterAmt+
            "marketSpotRate="+this.marketSpotRate+
            "marketForwardPts="+this.marketForwardPts+
            "marketForwardRate="+this.marketForwardRate+
            "spotMarkup="+this.spotMarkup+
            "clientSpotRate="+this.clientSpotRate+
            "clientForwardPts="+this.clientForwardPts+
            "clientForwardRate="+this.clientForwardRate+
            "fwdMarkup="+this.fwdMarkup+
            "accountName="+this.accountName+
            "allocationId="+this.allocationId+
            "channelCd="+this.channelCd+
            "clientCode="+this.clientCode+
            "clientName="+this.clientName+
            "entryDts="+this.entryDts+
            "entryUserCode="+this.entryUserCode+
            "oboAccount="+this.oboAccount+
            "oboClient="+this.oboClient+
            "oboEntryUser="+this.oboEntryUser+
            "usdEquivAmt="+this.usdEquivAmt+
            "orderId="+this.orderId+
            "orderRef="+this.orderRef+
            "privateComments="+this.privateComments+
            "clientComments="+this.clientComments+
            "salesGroupId="+this.salesGroupId+
            "userUpdatedFg="+this.userUpdatedFg+
            "forwardFirstOrder="+this.forwardFirstOrder+
            "reqForwardPts="+this.reqForwardPts+
            "failedAdjCalculation="+this.failedAdjCalculation+
            "messageId="+this.messageId+
            "brokerId="+this.brokerId+
            "secureToken="+this.secureToken+
            "rowId="+this.rowId+
            "proxySessionId="+this.proxySessionId+
            "svrRxTime="+this.svrRxTime+
            "svrTxTime="+this.svrTxTime+
            "cliTxTime="+this.cliTxTime+
            "cliRxTime="+this.cliRxTime+"]";
  };

  public validateInbound(): void {
  };

  public validateOutbound(): void {

  };
}
